/*
 * Makes the 2000s terminal's "Buddy List" IM opener (SATComponent's own
 * scheduleIM/_imScript) reference whichever item the visitor actually has
 * open, instead of the placeholder build's hardcoded "the plate carrier
 * listing" — shown on every single 2000s item regardless of what it is, a
 * handcuff pouch included.
 *
 * assets/sat-era-catalog-patch.js already replaced the demo records70/80/90/00
 * dictionaries with the real catalog, keyed by product id — this._imScript
 * itself was just never wired to read from that table. Wrapping scheduleIM
 * (not renderVals) on purpose: the very first line of the IM conversation is
 * baked into the static _imScript array and read once, synchronously, the
 * moment scheduleIM's own timers fire — by the time any renderVals patch
 * could react, the wrong line would already be logged. Rewriting
 * this._imScript[0].bot in place, right before calling through, means the
 * base method's existing setTimeout chain picks up the corrected line with
 * no other changes needed.
 */
(function () {
  'use strict';
  if (!window.SATComponent) { return; }

  var orig = window.SATComponent.prototype.scheduleIM;
  if (typeof orig !== 'function') { return; }

  window.SATComponent.prototype.scheduleIM = function () {
    var script = this._imScript;
    if (script && script[0]) {
      var rec = (this.records00 && this.state && this.state.active00)
        ? this.records00[this.state.active00] : null;
      var listingName = (rec && rec.name) ? rec.name.toLowerCase() : 'this listing';
      script[0].bot = "hey. you're on the " + listingName + " listing.";
    }
    return orig.apply(this, arguments);
  };
})();
